import React from "react";
import { Link } from "react-router-dom";
import { gradient_primary } from "../assets/data/colors";
import { MdLogin } from "react-icons/md";
import { HiX } from "react-icons/hi";

// the navigation drawer component
const NavigationDrawer = ({open, set_open, nav_links, special_buttom}) => {
    return (
        <div className={`fixed top-0 right-0 h-full w-64 z-50 sm:hidden flex flex-col bg-white dark:bg-gray-900 shadow-2xl transition-transform duration-300 ease-in-out ${open ? "translate-x-0" : "translate-x-full"}`}>
            <div className="flex items-center justify-between px-5 py-4" style={{ background: gradient_primary }}>
                <div />
                <button onClick={() => set_open(false)} className="text-white/80 hover:text-white transition-colors" aria-label="Close menu">
                    <HiX size={24} />
                </button>
            </div>

            <nav className="flex flex-col gap-1 px-4 py-6 flex-1">
                {nav_links.filter(item => !item.is_button).map(item => (
                    <Link
                        key={item.title}
                        to={`/${item.to}`}
                        onClick={() => set_open(false)}
                        className="capitalize text-gray-700 dark:text-gray-200 text-base font-medium px-4 py-3 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                    >
                        {item.title}
                    </Link>
                ))}
            </nav>

            {special_buttom && (
                <div className="px-4 pb-8">
                    <Link
                        to="/login"
                        onClick={() => set_open(false)}
                        className="flex items-center justify-center gap-2 w-full py-3 rounded-xl text-gray-100 font-medium text-base hover:opacity-85 transition-opacity"
                        style={{ background: gradient_primary }}
                    >
                        Login
                        <MdLogin size={20} />
                    </Link>
                </div>
            )}
        </div>
    );
};
export default NavigationDrawer;